import type { CommunicationStatsDto } from './dto/communication-stats.dto'
import { BaseService } from '../../infra/base.service'
import type { EventSourcesRepository } from './event-sources.repository'

export class EventSourcesService extends BaseService<null> {
    constructor(private eventSourcesRep: EventSourcesRepository) {
        super(eventSourcesRep)
    }

    async getAllFromEventSource(
        from: Date,
        to: Date,
        events: string[],
        ignoreComunication: boolean = false,
        onlyLastEvent: boolean = false,
    ) {
        return await this.eventSourcesRep.getAllFromEventSource(from, to, events, ignoreComunication, onlyLastEvent)
    }

    async getCommunicationStats(params: {
        from: string | Date
        to: string | Date
        sources?: string[]
        tzOffsetMinutes?: number
        channelId?: string
    }): Promise<CommunicationStatsDto> {
        return await this.eventSourcesRep.getCommunicationStats(params)
    }

    async getAllFiltered(params: any, useCacheIfNewerThanThisInSeconds: number = 0) {
        return await this.eventSourcesRep.getAllFiltered(params, useCacheIfNewerThanThisInSeconds)
    }
}
